export default "__VITE_ASSET__CmfL$95w__"